module.exports = __webpack_public_path__ + "img/iso-9001.f9f24f73.svg";